import { render, staticRenderFns } from "./hs-verification-pc.vue?vue&type=template&id=f7b48f90&scoped=true&"
import script from "./hs-verification-pc.vue?vue&type=script&lang=js&"
export * from "./hs-verification-pc.vue?vue&type=script&lang=js&"
import style0 from "./hs-verification-pc.vue?vue&type=style&index=0&id=f7b48f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b48f90",
  null
  
)

export default component.exports